module.exports = __webpack_public_path__ + "static/media/ex-register.e3d92195.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/assets-for-demo/example-pages/ex-register.jpg
// module id = 1225
// module chunks = 0